import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useDeleteRelatioship = (onSuccess) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error while deleting task");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (relationId) => {
      const axiosInstance = await createAxiosInstance();
      await axiosInstance.delete(`${tenantVal}/patientfamilymember/delete`, {
        data: {
          id: relationId,
          tenant: tenantVal,
        },
      });
    },
    onSuccess: () => {
      toast.success("Relation deleted successfully.");
      queryClient.invalidateQueries({ queryKey: ["relationships"] });
      queryClient.invalidateQueries({ queryKey: ["relationship"] });
      queryClient.invalidateQueries({ queryKey: ["familyMedicalHistory"] });
      onSuccess?.();
    },
    onError: handleNetworkError,
  });
};
